export function DevModeBanner({ provider }: { provider: 'web3auth' | 'dev-wallet' }) {
  if (provider !== 'dev-wallet') return null;
  return (
    <div className="cp-banner" role="alert">
      <strong>Dev wallet modu.</strong> Web3Auth client ID yapılandırılmadı; e-posta'dan
      yerel olarak deterministik bir cüzdan üretildi. Production'da bu modu KAPATIN —
      VITE_WEB3AUTH_CLIENT_ID'i ayarlayın.
    </div>
  );
}
